import useApiQuery from 'shared/hooks/use-api-query';
import {OccurrenceProps} from '../types';
import ordersKeys from '../util/orders-keys';

const useOrderOccurrences = (orderId: string) => {
  return useApiQuery<OccurrenceProps[]>({
    url: `/orders/${orderId}/occurrences`,
    queryKey: ordersKeys.occurrences(orderId),
  });
};

export default useOrderOccurrences;
